var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIconError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.62042V7.43292C13.75 9.77667 12.875 10.7142 10.6875 10.7142H10V8.63828C10 6.29453 9.125 5.35703 6.9375 5.35703H5V4.62042C5 2.27667 5.875 1.33917 8.0625 1.33917H10.6875C12.875 1.33917 13.75 2.27667 13.75 4.62042Z",
    stroke: "#D97777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8931 7.56683V10.3793C10.8931 12.7231 10.0181 13.6606 7.83057 13.6606H5.20557C3.01807 13.6606 2.14307 12.7231 2.14307 10.3793V7.56683C2.14307 5.22308 3.01807 4.28558 5.20557 4.28558H7.83057C10.0181 4.28558 10.8931 5.22308 10.8931 7.56683Z",
    fill: "#FFF2F2",
    stroke: "#D97777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconError);
export default __webpack_public_path__ + "static/media/copyIconError.76ff6e4a483cf216799ca31967473d21.svg";
export { ForwardRef as ReactComponent };